/**************************************************************************************************
 *
 *  This is the main container for all project report views: 
 *
 *  This views are individual components that will fit into the detail-container parent element
 *  defined in this container.
 *
**************************************************************************************************/

import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import animator from '../../../helpers/animator';
import dataModel from '../../../models/DataModel';
import ActivityLogTable from './ActivityLogTable';
import WaitSpinner from '../../../components/WaitSpinner';
import ReportHeader from '../ReportHeader';
import ReportFilter from '../ReportFilter';
import ActivityFilter from './ActivityFilter';

import anime from 'animejs';

import './ActivityLog.scss';
import EventHistoriesCollection from '../../../dao/collections/EventHistoriesCollection';

const eventHistoryDescriptor = {
  event_history: {
    activity: {},
    activity_sub_type: {},
    user_who_performed_action: {
      companies: {},
    },
  },
};

export class ActivityLog extends BaseComponent {

  constructor(props) {
    super(props);
    const perPage = Math.floor((window.innerHeight - 194) / 64) + 2;
    this.eventHistoriesCollection = EventHistoriesCollection.build(perPage, {}, props.currentUser.id, props.currentCompany.id, eventHistoryDescriptor);
    this.animator = new animator();
    const collectionFilter = this.eventHistoriesCollection.getFilter();
    
    this.state = {
      loading: false,
      sortField: collectionFilter ? collectionFilter.sortField : '',
      view: null,
      cleared: false,
      searchString: collectionFilter ? collectionFilter.searchString : '',
      totalEventHistories: null,
      filter: collectionFilter,
      filterDisplayed: collectionFilter ? collectionFilter.filterDisplayed : false,
      filterActive: false, 
      displayPopUp: null,
      fileName: null,
    };

    this.handleDownloadLocation = this.handleDownloadLocation.bind(this);
    this.changeFileName = this.changeFileName.bind(this);
    this.handleClosePopup = this.handleClosePopup.bind(this);
  }
  
  componentDidMount() {
    super.componentDidMount()
    this._isMounted = true
    if (this.props.currentUser){
      this.setState({ sortField: "created_at", ascending: false }, () => this.handleFilterChange(this.state.filter, "created_at", false, true))
    }
    this.handleFilterUpdate(this.state.filter);
    this.handleActivityLogDownload();

    if (this.state.filterDisplayed) {
      this.handleFilterActive(true)
    }
  }

  componentWillUnmount() {
    this._isMounted = false
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
      this.searchTimer = null
    }
  }

      //to filenamepopup
  changeFileName(value) {
    this.setState({ fileName: value  }, () => this.handleActivityLogDownload());
  }
  
  handleDownloadLocation() {
      
    this.setState({ displayPopUp: true });
      
    return; 
  }
  
  handleClosePopup() {
    this.setState({ displayPopUp: false });
  }
    //end

  componentDidUpdate(prevProps) {
    if(prevProps.currentCompany != this.props.currentCompany && this.props.currentCompany){
      this.handleFilterChange(null, 'created_at', false, true);
    }
    if (prevProps.currentUser != this.props.currentUser && this.props.currentUser) {
      this.setState({ sortField: 'created_at', ascending: false });
      this.handleFilterChange(null, 'created_at', false, true);
    }
    else if (prevProps.permissions != this.props.permissions && this.props.permissions) {
      if (this.props.currentUser) {
        this.setState({ sortField: 'created_at', ascending: false });
        this.handleFilterChange(null, 'created_at', false, true);
      }
    }
  }

  handleSelectUser(user) {
    if (this.props.permissions.canEditProject) {
      if (user) {
        this.setState({ selectedUser: user });
      }
    }
  }

  handleCloseUserPopup() {
    this.setState({ selectedUser: null });
  }

  handleFilterChange(filter, sortField, ascending, noRefresh, dontSearch, cleared) {
    this.setState({ loading: true });
    if (!filter) {
      filter = {};
    }
    this.refresh = !noRefresh;
    const collectionFilter = {
      searchString: dontSearch ? '' : this.state.searchString,
      sortField: sortField || this.state.sortField,
      ascending: ascending || this.state.ascending,
      activityTypeId: filter.activityTypeId,
      activitySubTypeId: filter.activitySubTypeId,
      startDate: filter.startDate,
      endDate: filter.endDate,
      filterDisplayed: filter.filterDisplayed || false,
    };
    this.eventHistoriesCollection.setFilter(collectionFilter);
    this.eventHistoriesCollection.fetchCurrent().then(collectionData => {
      if (!this._isMounted) return
      this.setState({
        loading: false,
        filter: collectionFilter,
        sortField,
        eventHistories: collectionData.event_histories,
        totalEventHistories: collectionData.meta.total_records,
        cleared: !this.state.cleared
      }, () => this._isMounted && this.handleActivityLogDownload())
    })
  }

  handleSearchChange(searchString) {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    // const filter = this.state.filter
    this.refresh = true;
    this.searchTimer = setTimeout(() => {
      this.searchTimer = null
      if (!this._isMounted) return
      const collectionFilter = this.eventHistoriesCollection.getFilter()
      collectionFilter.searchString = searchString
      this.eventHistoriesCollection.setFilter(collectionFilter)
      this.eventHistoriesCollection.fetchCurrent().then(collectionData => {
        if (!this._isMounted) return
        this.setState({ eventHistories: collectionData.event_histories, searchString, totalEventHistories: collectionData.meta.total_records }, () => this._isMounted && this.handleActivityLogDownload())
      })
    }, 400)
  }

  handleSortChange(sortField, ascending, noRefresh) {
    this.refresh = !noRefresh;

    const collectionFilter = this.eventHistoriesCollection.getFilter();
    collectionFilter.sortField = sortField || this.state.sortField;
    collectionFilter.ascending = ascending;
    this.eventHistoriesCollection.setFilter(collectionFilter);
    this.eventHistoriesCollection.fetchCurrent().then(collectionData => {
      if (!this._isMounted) return
      this.setState({
        eventHistories: collectionData.event_histories,
        sortField: sortField,
        ascending: ascending
      }, () => this._isMounted && this.handleActivityLogDownload())
    })
  }

  handleActivityLogDownload() {
    const { filter, searchString, ascending, sortField } = this.state;
    const activity = filter && filter.activityTypeId ? filter.activityTypeId : '';
    const activitySubType = filter && filter.activitySubTypeId ? filter.activitySubTypeId : '';
    const startDate = filter && filter.startDate ? filter.startDate : '';
    const endDate = filter && filter.endDate ? filter.endDate : '';

    const pathname = `${process.env.REACT_APP_API}/event_histories/export_event_histories?current_company=${localStorage.current_company_id}`;
    let search = '';
    if (sortField) {
      search += `&order=${sortField}`;
      search += ascending ? ',asc' : ',desc';
    }
    if (activity) {
      search += activity ? `&activity=${activity}` : '';
      search += activitySubType ? `&activity_sub_type=${activitySubType}` : '';
    }
    if (searchString) {
      search += searchString ? `&keywords=${searchString}` : '';
    }

    let sDate = new Date(startDate).toUTCString();
    let eDate = new Date(endDate).toUTCString();

    let utcStart = Date.parse(sDate);
    let utcEnd = Date.parse(eDate);
    utcEnd += 24 * 60 * 60 * 1000 -1;

    let offset = (new Date().getTimezoneOffset() * 60 * 1000);

    utcStart += offset;
    utcEnd += offset;

    search += startDate ? `&start_date=${Math.floor(utcStart / 1000)}` : '';
    search += endDate ? `&end_date=${Math.floor(utcEnd / 1000)}` : '';
    search += `&filename=${this.state.fileName}`;
    search += `&token=${localStorage.token}`;

    this.setState({ exportLink: (pathname + search) });
  }

  handleLogExport() {
    const { filter } = this.state;
    const filtered = filter && Object.keys(filter).length;
    this.props.handleLogExport(filtered, 'Activity Log Report');
  }

  handleGetMoreEventHistories(callBack) {
    this.eventHistoriesCollection.fetchNext().then(collectionData => {
      if (!this._isMounted) return
      this.setState({ totalEventHistories: collectionData.meta.total_records, eventHistories: collectionData.event_histories })
      callBack(collectionData.event_histories)
    })
  }

  async handleFilterActive(filterDisplayed) {
    if (!this.filterInProgress) {
      this.filterInProgress = true;
      if (filterDisplayed) {
        await anime({
          targets: '.ReportFilter',
          height: 136,
          easing: 'easeInOutCubic',
          duration: 500,
          begin: () => this._isMounted && this.setState({ filterDisplayed: true }),
          complete: () => { this.filterInProgress = false }
        })
      
      }
      else {
        await anime({
          targets: '.ReportFilter',
          height: 0,
          easing: 'easeInOutCubic',
          duration: 500,
          complete: () => {
            if (this._isMounted) this.setState({ filterDisplayed: false })
            this.filterInProgress = false
          }
        })
      }
      let filter = this.eventHistoriesCollection.getFilter();
      filter.filterDisplayed = filterDisplayed;
      this.eventHistoriesCollection.setFilter({ ...filter });
    }
  }

  handleFilterUpdate(filter) {
    if (filter && (filter.startDate || filter.endDate || filter.activityTypeId || filter.activitySubTypeId)) {
      this.setState({ filter, filterActive: true });
      this.handleFilterChange(filter);
    }
    else if (filter && filter.filterDisplayed) {
      //if it got here, that means no filters were set
      this.setState({ filter, filterActive: false });
      this.handleFilterChange(filter);
    }
    else {
      this.setState({ filter: null, filterActive: false });
      this.handleFilterChange(null);
    }
  }

  render() {
    let waitSpinner = null;
    if (this.state.loading) {
      waitSpinner = <WaitSpinner />;
    }

    let activityLogSearchFilter = (
      <ReportFilter>
        <ActivityFilter
          handleFilterChange={this.handleFilterUpdate}
          selectedFilters={this.state.filter ? this.state.filter : {}}
          handleActivityDropdown={this.handleActivityDropdown}
        />
      </ReportFilter>
    );

    return (

      <div className="activity-log-container"
        ref={(element) => { this.mainContainer = element; }}>
        <ReportHeader 
          reportTitle={'Activity Log'}
          reportCount={this.state.totalEventHistories}
          exportLink={this.state.exportLink}
          logExport={this.handleLogExport}
          handleFilterActive={this.handleFilterActive}
          handleSearchInput={this.handleSearchChange}
          searchString={this.state.searchString}
          filterActive={this.state.filterActive}
          filterDisplayed={this.state.filterDisplayed}
          handleDownloadLocation={this.handleDownloadLocation}
          handleClosePopup={this.handleClosePopup}
          displayPopUp={this.state.displayPopUp}
          changeFileName={this.changeFileName}
          filename={'activity_log_reports'}
        />
        <div>
          { activityLogSearchFilter }
        </div>
        <div className="activity-log-body">
          <ActivityLogTable
            refresh={this.refresh}
            selectUser={this.handleSelectUser} 
            filter={this.state.filter} 
            searchString={this.state.searchString} 
            sortField={this.state.sortField} 
            ascending={this.state.ascending}
            handleSortChange={this.handleSortChange}
            getMoreEventhistories={this.handleGetMoreEventHistories}
            inProgress={this.state.loading}
            searching={this.state.searching}
            filterCleared={this.state.cleared}
            eventHistories={this.state.eventHistories}
            totalEventHistories={this.state.totalEventHistories || 0}
            filterActive={this.state.filterActive}
            filterDisplayed={this.state.filterDisplayed}
          />

        </div>
        {waitSpinner}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(ActivityLog);



// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/ActivityLog/index.js